const PLACEHOLDER_TEXT =
  'Auf dieser Seite werden Ihnen Analysen vom Tagebuch angezeigt, wie die Nährwerteverteilung und die Kalorienbilanz. Aktuell gibt es, noch keinen Eintrag im Tagebuch daher wird Ihnen noch keine Analyse angezeigt. Fügen Sie jetzt über die Suche ein Nahrungsmittel, ein Rezept oder eine Aktivität zum Tagebuch hinzu. Dazu klicken Sie in das Suchfeld über dem Dashboard und suchen die einzelnen Nahrungsmittel oder Rezepte und fügen diese über «Hinzufügen» und «Speichern» zu Ihrem Tagebuch hinzu.'

export const PLACEHOLDER_TEXT_CUSTOM =
  'Es sind keine Daten für den ausgewählten Zeitraum verfügbar. Bitte wählen Sie einen anderen Zeitraum aus oder tragen Sie für diesen Zeitraum etwas in Ihr Ernährungstagebuch ein.'

export const PLACEHOLDER_TEXT_CUSTOM_TITLE = 'Nichts zu finden'

export default PLACEHOLDER_TEXT
